<template>

  <div id="app" style="height:100%">
    <router-view/>
  </div>
</template>
<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
export default {
  data() {
    return {
      zh_CN:'zh_CN',
    };
  },
  name: 'App'
}
</script>





// WEBPACK FOOTER //
// src/App.vue